import jQuery from 'jquery';

jQuery(function($) {
  let $equipment = $('.equipment');

  $equipment.each(function() {
    let $equipmentsLists = $equipment.find('.equipment__list');
    let $equipmentsItems = $equipmentsLists.find('.equipment__item');
    let $equipmentsTitles = $equipmentsItems.find('.equipment__subtitle');
    $equipmentsItems.find('.equipment__wrapper').slideUp(0);

    $equipmentsTitles.append('<svg class="equipment__icon" width="28" height="28" viewBox="0 0 28 28" fill="none"' + ' xmlns="http://www.w3.org/2000/svg"><circle cx="14" cy="14" r="13" stroke="#002677" stroke-width="2"/><path d="M14 21L14 7" stroke="#002677" stroke-width="2" stroke-linejoin="round"/><path d="M7 14L21 14" stroke="#002677" stroke-width="2" stroke-linejoin="round"/></svg>');

    $equipmentsTitles.on('click', function() {
      let $equipmentTitle = $(this);
      let $equipmentItem = $equipmentTitle.closest('.equipment__item');
      let $equipmentWrapper = $equipmentItem.find('.equipment__wrapper');
      let isActive = $equipmentItem.hasClass('equipment__item--active');

      if (isActive) {
        $equipmentWrapper.slideUp(200);
      } else {
        $equipmentWrapper.slideDown(200);
      }
      $equipmentItem.toggleClass('equipment__item--active', !isActive);
    });

    $equipmentsTitles.first().trigger('click');
  });
});
